import { Center } from '@euler/components/Center';
import { FormElementClear } from '@euler/components/form/elements-ui/Clear';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { useLayout } from '@euler/functions/ux/useLayout';
import { AnimatePresence } from 'moti';
import { ReactNode, memo } from 'react';
import { LayoutRectangle, StyleProp, View, ViewStyle } from 'react-native';

export type ClearableProps = {
  showClearButton?: boolean;
  style?: StyleProp<ViewStyle>;
  clearStyle?: StyleProp<ViewStyle>;
  buttonStyle?: StyleProp<ViewStyle>;
  iconSize?: number;
  iconColor?: string;
  children?:
    | ReactNode
    | ((
        showClearButton: boolean | undefined,
        clearLayout: LayoutRectangle | undefined,
      ) => ReactNode);
  onClear?: () => void;
};

export const Clearable = memo(
  ({
    showClearButton,
    style,
    clearStyle,
    buttonStyle,
    iconSize,
    iconColor,
    onClear,
    ...props
  }: ClearableProps) => {
    const { rpx } = useResponsiveContext();
    const [layout, onLayout] = useLayout();
    const children =
      typeof props.children === 'function'
        ? props.children(showClearButton, showClearButton ? layout : undefined)
        : props.children;
    return (
      <View style={style}>
        {children}
        <AnimatePresence>
          {showClearButton && (
            <Center
              style={[
                {
                  position: 'absolute',
                  right: 0,
                  top: 0,
                  bottom: 0,
                  width: rpx(32),
                },
                clearStyle,
              ]}
              onLayout={onLayout}
            >
              <FormElementClear
                style={buttonStyle}
                iconSize={iconSize}
                iconColor={iconColor}
                onPress={onClear}
              />
            </Center>
          )}
        </AnimatePresence>
      </View>
    );
  },
);
